import { registerComponent, triggerEvent } from "helpers";
import WYATTDialog from "wyatt-dialog";

registerComponent(
  "wyatt-drawer",
  class WyattDrawer extends WYATTDialog {
    open(event) {
      super.open(event);

      triggerEvent(this.dialog, "drawerOpen");
    }

    close() {
      super.close();

      triggerEvent(this.dialog, "drawerClose");
    }
  },
);
